import React from 'react';
import { useSelectNotifications } from './store/selectors';
import { NotificationsList as NotificationsListCore } from '@instinet-analytics/semantic-ui-components';
import { useDispatch } from 'store/hooks';
import { hideNotificationAction } from 'notification/store/actions';

export default function NotificationsList() {
    const { notifications } = useSelectNotifications();
    const dispatch = useDispatch();

    const onCloseNotification = (id: string) => {
        dispatch(hideNotificationAction(id));
    };

    return (
        <NotificationsListCore
            notifications={notifications}
            onCloseNotification={onCloseNotification}
        />
    );
}
